<template>
  <div
    :class="[
      'sidebar bg-white border-end position-fixed h-100 shadow-sm',
      { 'sidebar-open': isOpen },
    ]"
  >
    <div class="text-center py-4 border-bottom">
      <img
        src="@/assets/temple-logo.png"
        alt="Temple Logo"
        width="80"
        height="80"
        class="rounded-circle mb-2"
      />
      <h5 class="fw-bold text-brown">{{ templeName }}</h5>
    </div>

    <ul class="list-unstyled p-3 mt-3">
      <li v-for="link in links" :key="link.path" class="mb-3">
        <router-link
          :to="link.path"
          class="text-decoration-none d-block py-2 px-3 rounded sidebar-link"
          active-class="active-link"
          @click="$emit('close-sidebar')"
        >
          <i :class="['bi', link.icon, 'me-2']"></i>{{ link.name }}
        </router-link>
      </li>
    </ul>

    <div class="mt-auto text-center py-3 small text-muted border-top">
      Powered by <strong>MySoftCode</strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: { type: Boolean, default: false },
  },
  emits: ["close-sidebar"],
  data() {
    return {
      templeName: "Sri Sambuddha Viharaya",
      links: [
        { name: "Home", path: "/", icon: "bi-house" },
        { name: "About", path: "/about", icon: "bi-info-circle" },
        { name: "Events", path: "/events", icon: "bi-calendar-event" },
        { name: "Gallery", path: "/gallery", icon: "bi-images" },
        { name: "Contact", path: "/contact", icon: "bi-telephone" },
        { name: "Donations", path: "/donations", icon: "bi-heart" },
      ],
    };
  },
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  left: -250px;
  top: 0;
  transition: left 0.3s ease;
  z-index: 1040;
  display: flex;
  flex-direction: column;
}
.sidebar-open {
  left: 0;
}
.sidebar-link {
  color: #4a3c2a;
  font-weight: 500;
}
.sidebar-link:hover {
  background-color: #f4ede0;
  color: #6b4e1e;
}
.active-link {
  background-color: #e5c89c;
  color: #4a3200 !important;
}
.text-brown {
  color: #6b4e1e;
}
</style>
